import { render, staticRenderFns } from "./infography.vue?vue&type=template&id=1dad598c&"
import script from "./infography.vue?vue&type=script&lang=js&"
export * from "./infography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports